import { FC } from 'react';
import { ConnectivityView } from './connectivity-view';

export const ConnectivityPanel: FC = () => (
  <>
    <div className="pt-7">
      <ConnectivityView />
    </div>
  </>
);
